// Viser le module qui définit `useNuxtApp` plutôt qu'un baril, comme le reste du
// runtime vendorisé (`nuxt-auth-sanctum`, `nuxt-permissions`).
import { useNuxtApp } from "#app/nuxt";

/** Tenant résolu depuis l'hôte par le plugin du module. */
export const useTenant = (): string => useNuxtApp().$tenant as string;
